
import {
  createApp,
  defineComponent,
  ref,
  reactive,
  onBeforeMount,
  onMounted,
  nextTick,
} from "vue";
import CustomAudio from "@/components/CustomAudio.vue";
import { unLock } from "@/utils/liner-lock";

export default defineComponent({
  name: "ChoiceQuestion",
  props: {
    question: Object,
    disabled: Boolean,
    showQuestionNum: {
      type: Boolean,
      default: true,
    },
    showQuestionScore: {
      type: Boolean,
      default: true,
    },
  },
  components: { CustomAudio },
  setup(props, ctx) {
    const win: any = window;
    const dvRef = ref(null);
    const disabledAnswer = ref(props.disabled);
    let correctOption: number = ref(
      props.question?.correct_option?.option_id || undefined
    );
    // 传进来的题目
    let questionData: any = ref(props.question);
    // 题目的选项
    let options = ref(props.question?.question_params.options);
    // 选中的答案
    let currentAnswer: any = ref(undefined);
    // 选项图片状态
    let clickImgState: any = ref(false);
    // 选项图片url
    let clickImgUrl: any = ref("");
    let updateImgH5List: any = ref([]);
    const testOptions: any = ref([
      {
        content: `<div>2<img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-53.jpg">
          <img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-57.jpg">
          <img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-54.jpg">
          <img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-55.jpg">
          </div>`,
        is_correct: 1,
        option_id: -2,
      },
      {
        content: `<div>1<img src="https://devppublic.jilingshu.com.cn/exam_center/institution/192/20221011/-rc-upload-1665467697221-15.jpg"></div>`,
        is_correct: 1,
        option_id: -1,
      },
      {
        content: `<div>3<img src="https://devppublic.jilingshu.com.cn/exam_center/institution/192/20221011/-rc-upload-1665467697221-15.jpg"></div>`,
        is_correct: 1,
        option_id: -3,
      },
      {
        content: `<div>4<img src="https://devppublic.jilingshu.com.cn/exam_center/institution/192/20221011/-rc-upload-1665467697221-15.jpg"></div>`,
        is_correct: 1,
        option_id: -4,
      },
    ]);
    // 转换数据
    const handleTitleHtml = () => {
      if (questionData.value?.answer_params !== undefined) {
        currentAnswer.value = questionData.value.answer_params.option_id;
      } else {
        currentAnswer.value = undefined;
      }
      let html = questionData.value?.title;
      const audioExp = new RegExp("<kbd>.*?</kbd>", "g");
      const srcExp = new RegExp('src="([^"]+)');
      let match;
      let contentHtml = html;

      while ((match = audioExp.exec(html)) !== null) {
        contentHtml = contentHtml.replace(
          '<span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span>',
          ""
        );
        const audioStr = match[0];
        const srcList: any = srcExp.exec(audioStr);
        const src = srcList?.length > 0 ? srcList[0] : "";
        const srcNum = src.replace(`src="`, "");
        const newStr = `<div class="dv-audio"><custom-audio musicUrl="${srcNum}" /></div>`;
        contentHtml = contentHtml.replace(audioStr, newStr);
      }
      const comp = defineComponent({
        template: `${contentHtml}`,
      });
      const app = createApp(comp);
      app.component("custom-audio", CustomAudio);
      nextTick(() => {
        app.mount("#dvCompile");
      });
    };
    // 选项数据转换
    const handleOptionHtml = () => {
      let match: any = [];
      let imgH5: any = [];
      const srcExp = new RegExp('src="([^"]+)');
      const imgExp = new RegExp("<img src", "g");
      const imgH5Exp = new RegExp("<img.*?>", "g");
      let updateImgH5: any;
      // 遍历出第一个选项
      options.value.forEach((data: any) => {
        // 处理选项里每个<img>标签
        let content: any = data.content;
        while ((imgH5 = imgH5Exp.exec(data.content)) !== null) {
          const srcList: any = srcExp.exec(imgH5);
          const src = srcList?.length > 0 ? srcList[0] : "";
          const srcTxt = src.replace(`src="`, "");
          const srcImg = `<img onClick="clickImg('${srcTxt}')" src`;
          updateImgH5 = imgH5[0].replace(imgExp, srcImg);
          content = content.replace(imgH5[0], updateImgH5);
        }
        data.content = content;
        match.push(data);
      });
      updateImgH5List.value = match;
    };
    // 保存选项值
    const handleAnswer = (optionId: any) => {
      if (!props.disabled) {
        if (currentAnswer.value === optionId) {
          currentAnswer.value = undefined;
        } else {
          currentAnswer.value = optionId;
        }
      }
    };

    // 父组件获取答案等参数
    const getAnswer = () => {
      // console.log("我是子组件11111", questionData.value);
      // console.log("currentAnswer.value", currentAnswer.value);
      // type:0|不保存答案 1｜保存答案
      // console.log("保存获取答案");
      if (currentAnswer.value === undefined) {
        if (questionData.value.answer_params === undefined) {
          return { type: 0 };
        } else {
          return {
            answer_params: undefined,
            type: 1,
          };
        }
      } else {
        if (questionData.value.answer_params === undefined) {
          return {
            answer_params: { option_id: currentAnswer.value },
            type: 1,
          };
        } else {
          if (
            questionData.value.answer_params.option_id === currentAnswer.value
          ) {
            return { type: 0 };
          } else {
            return {
              answer_params: { option_id: currentAnswer.value },
              type: 1,
            };
          }
        }
      }
    };

    const checkIsCorrect = () => {
      let isCorrect = false;
      if (questionData.value.answer_params) {
        isCorrect =
          questionData.value.answer_params.option_id ===
          questionData.value.correct_option.option_id;
      }

      return isCorrect;
    };
    // 选项图片放大
    const clickImg = (url: any) => {
      console.log("图片放大", url);
      clickImgUrl.value = url;
      clickImgState.value = !clickImgState.value;
      event?.stopPropagation();
    };
    onBeforeMount(() => {
      handleTitleHtml();
      handleOptionHtml();
    });
    onMounted(() => {
      unLock();
      win.clickImg = clickImg;
    });
    return {
      disabledAnswer,
      questionData,
      options,
      dvRef,
      currentAnswer,
      correctOption,
      props,
      handleAnswer,
      getAnswer,
      checkIsCorrect,
      clickImg,
      clickImgState,
      clickImgUrl,
      updateImgH5List,
    };
  },
});
